<template>
  <cumulus-edit-form
    ref="form"
    :icon="icon"
    :title="title"
    :new-item="new_item"
    @escape="escape"
    @save="save"
    @remove="remove"
  >
    <template v-slot:editform>
      <edit-form
        :logbook-general="edited_item"
      />
    </template>
  </cumulus-edit-form>
</template>

<script>
  // Utilities
  import { call, get } from 'vuex-pathify'
  import { format, isValid, parse, subHours } from 'date-fns'

  export default {
    name: 'LogbookGeneralEdit',
    components: {
      EditForm: () => import('@/layouts/default/edit/LogbookGeneral'),
    },
    data: function () {
      return {
        icon: '$edit',
        title: 'flight_datas',
        edited_item_id: -1,
        edited_item: {
          night_time: '00:00',
          ifr_time: '00:00',
          sim_time: '00:00',
          takeoff_day: 1,
          landing_day: 1,
          takeoff_night: 0,
          landing_night: 0,
          pft_pic: false,
          pft_dual: false,
          pft_instructor: false,
        },
        loading: false,
        prevRoute: '',
        saved: false,
      }
    },
    computed: {
      new_item () { return this.edited_item_id === -1 },
      profile: get('auth/profile'),
    },
    watch: {
      'edited_item.takeoff_time': {
        handler () {
          this.calcFlightTime()
        },
      },
      'edited_item.landing_time': {
        handler () {
          this.calcFlightTime()
        },
      },
      'edited_item.takeoff_day': {
        handler () {
          console.log(this.edited_item.landing_day)
          if (this.edited_item.landing_night === 0) {
            this.edited_item.landing_day = this.edited_item.takeoff_day
          }
        },
      },
      'edited_item.pft_instructor': {
        handler () {
          this.edited_item.pft_pic = this.edited_item.pft_instructor
        },
      },
      'edited_item.pft_copilot': {
        handler () {
          this.edited_item.pft_pic = !this.edited_item.pft_copilot
        },
      },
      'edited_item.pft_dual': {
        handler () {
          this.edited_item.pft_pic = !this.edited_item.pft_dual
        },
      },
      'edited_item.pft_pic': {
        handler () {
          if (this.edited_item.pft_pic) {
            this.edited_item.pft_copilot = false
            this.edited_item.pft_dual = false
            this.edited_item.pic_name = this.profile.user_name
          }
        },
      },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetchEditedItem: call('logbookGeneral/fetch'),
      insertEditedItem: call('logbookGeneral/insert'),
      updateEditedItem: call('logbookGeneral/update'),
      deleteEditedItem: call('logbookGeneral/delete'),
      async fetch () {
        this.edited_item_id = parseInt(this.$route.params.id)
        this.loading = true
        if (!this.new_item) {
          this.fetchEditedItem({ id: this.edited_item_id }).then(response => {
            this.edited_item = response
            this.loading = false
          })
        }
      },
      async save () {
        try {
          this.loading = true
          if (this.new_item) {
            await this.insertEditedItem(
              this.edited_item,
            ).then(response => {
              this.escape()
            }).catch(e => {
              this.loading = false
              this.$refs.form.setErrors(e)
              console.log(e)
            })
          } else {
            await this.updateEditedItem(
              this.edited_item,
            ).then(response => {
              this.escape()
            }).catch(e => {
              this.loading = false
              this.$refs.form.setErrors(e)
              console.log(e)
            })
          }
        } catch (e) {
          /* this.$buefy.notification.open({
            message: this.$t('app.error.general'),
            type: 'is-danger',
          }) */
        }
      },
      async remove () {
        try {
          this.loading = true
          await this.deleteEditedItem(
            { id: this.edited_item_id },
          ).then(response => {
            this.escape()
          }).catch(e => {
            this.loading = false
            this.$refs.form.setErrors(e)
            console.log(e)
          })
        } catch (e) {
          /* this.$buefy.notification.open({
            message: this.$t('app.error.general'),
            type: 'is-danger',
          }) */
        }
      },
      escape () {
        this.$router.push(this.prevRoute.path).catch(() => {})
      },
      calcFlightTime () {
        const takeoffTime = parse(this.edited_item.takeoff_time, 'HH:mm', new Date())
        const landingTime = parse(this.edited_item.landing_time, 'HH:mm', new Date())
        if (isValid(takeoffTime) && isValid(landingTime)) {
          this.edited_item.flight_time = format(subHours(landingTime - takeoffTime, 1), 'HH:mm')
        } else {
          this.edited_item.flight_time = '00:00'
        }
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }
</script>
